import { useEffect, useMemo } from "react";
import useSWR from "swr";
import useLocalStorage from "./useLocalStorage.js";
import { fetchStopSearchResults } from "./stopSearchResource.js";
import { favouriteDetailsKey, mergeFavouriteStopDetails, buildFavouriteDetailUrls } from "./favouriteStopDetails.js";
const emptyCache = Object.freeze({});
export default function useFavouriteStopDetails(useStorage = useLocalStorage) {
  const [favourites, setFavourites,, hydrated] = useStorage("favourites", []);
  const [cache, setCache,, cacheHydrated] = useStorage(favouriteDetailsKey, emptyCache);
  const ids = useMemo(() => [...new Set((Array.isArray(favourites) ? favourites : []).filter(id => typeof id === "string" && id))].sort(), [favourites]);
  const key = hydrated && ids.length ? `/api/stops/search?stop_ids=${encodeURIComponent(JSON.stringify(ids))}` : null;
  const {
    data
  } = useSWR(key, async () => {
    const rows = [];
    // No overall cap: every favourite is checked, in URL-safe batches.
    for (const url of buildFavouriteDetailUrls(ids)) {
      rows.push(...(await fetchStopSearchResults(url)));
    }
    return rows;
  }, {
    revalidateOnFocus: false,
    revalidateOnReconnect: true,
    dedupingInterval: 60000
  });
  useEffect(() => {
    if (!hydrated || !cacheHydrated) return;
    if (mergeFavouriteStopDetails(cache, data || [], ids) === cache) return;
    void setCache(current => mergeFavouriteStopDetails(current, data || [], ids));
  }, [data, cache, setCache, ids, hydrated, cacheHydrated]);
  return {
    favourites,
    setFavourites,
    details: cache || emptyCache,
    setDetails: setCache
  };
}